import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/auth/Login'
import Logout from '@/auth/Logout'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import DealerDefinedFees from '@/views/DealerDefinedFees'
import QuotePolicies from '@/views/QuotePolicies'
import QuotePolicyDetail from '@/views/QuotePolicyDetail'
import Inventory from '@/views/Inventory'
import EditInventory from '@/views/EditInventory'
import AddInventory from '@/views/AddInventory'
import Lenders from '@/views/Lenders'
import MarketSpecificSettings from '@/views/MarketSpecificSettings'
import CalculationSettings from '@/views/CalculationSettings'
import BankFeeMarkup from '@/views/BankFeeMarkup'
import RateMarkup from '@/views/RateMarkup'
import RateMarkupEx from '@/views/RateMarkupEx'
import MyProfile from '@/views/MyProfile'
import UserManagement from '@/views/UserManagement'
import UserManagementDetail from '@/views/UserManagementDetail'
import mDrive from '@/views/mDrive'
import DealerSettings from '@/views/DealerSettings'
import mProve from '@/views/mProve'
import mProveReport from '@/views/mProveReport'
import mProveSettings from '@/views/mProveSettings'
import mProveSettingsAdd from '@/views/mProveSettingsAdd'
import mProveRawData from '@/views/mProveRawData'
import VehicleEquipment from '@/views/VehicleEquipment'
import RebateRegions from '@/views/RebateRegions'
import mGaugeVehicleSampling from '@/views/mGaugeVehicleSampling'
import mGaugeRunReport from '@/views/mGaugeRunReport'
import mGaugeSettings from '@/views/mGaugeDefaultSettings'
import mGaugeReportHistory from '@/views/mGaugeReportHistory'
import mGaugeVehicleSets from '@/views/mGaugeVehicleSets'
import mGaugeUsageSummary from '@/views/mGaugeUsageSummary'
import mGaugePricingRules from '@/views/mGuagePricingRules'
import mGuagePricingRuleDetail from '@/views/mGuagePricingRuleDetail'
import mScopeVehicleSets from '@/views/mScopeVehicleSets'
import mScopeCompetitiveVehicleMapping from '@/views/mScopeCompetitiveVehicleMapping'
import mScopeSettings from '@/views/mScopeDefaultSettings'
import mScopeRunReport from '@/views/mScopeRunReport'
import mScopeReportHistory from '@/views/mScopeReportHistory'
import mScopeVehicleSampling from '@/views/mScopeVehicleSampling'
// import mScopeUsageSummary from '@/views/mScopeUsageSummary'
import SettingsDifferences from '@/views/SettingsDifferences'
import mDriveWizard from '@/views/mDrive/mDriveWizard'
import mDriveSignup from '@/views/mDrive/mDriveSignup'
import mDriveRegistration from '@/views/mDrive/mDriveRegistration'
import mDriveConfirmation from '@/views/mDrive/mDriveConfirmation'
import mDriveEnrollment from '@/views/mDrive/mDriveEnrollment'
import eula from '@/views/mDrive/EULA'
import DealerInformation from '@/views/DealerInformation'
import PVIMarkets from '@/views/PVIMarkets'
import PVISettings from '@/views/PVIReports'
import PVIEmailTemplate from '@/views/PVIEmailSettings'
import PVIReportHistory from '@/views/PVIReportHistory'

// No SideBar Views
import ProgramInfo from '@/views/ProgramInfo'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'mGauge/VehicleSampling',
          name: 'mGauge Vehicle Sampling',
          component: mGaugeVehicleSampling,
          meta: {roles: ['User', 'Admin'], subscription: ['mGauge']}
        },
        {
          path: 'mGauge/Settings',
          name: 'mGauge Report Default Settings',
          component: mGaugeSettings,
          meta: { roles: ['Admin'], subscription: ['mGauge'] }
        },
        {
          path: 'mGauge/RunReport',
          name: 'mGauge Report Templates',
          component: mGaugeRunReport,
          meta: {roles: ['Admin'], subscription: ['mGauge']}
        },
        {
          path: 'mGauge/ReportHistory',
          name: 'mGauge Reports',
          component: mGaugeReportHistory,
          meta: {roles: ['User', 'Admin'], subscription: ['mGauge', 'PVIREPORT']}
        },
        {
          path: 'mGauge/VehicleSets',
          name: 'mGauge Vehicle Sets',
          component: mGaugeVehicleSets,
          meta: {roles: ['Admin'], subscription: ['mGauge', 'PVIREPORT']}
        },
        {
          path: 'mGauge/mGaugeUsageSummary',
          name: 'mGauge Usage Summary',
          component: mGaugeUsageSummary,
          meta: {roles: ['Admin'], subscription: ['mGauge']}
        },
        {
          path: 'mGauge/PricingRules',
          name: 'mGauge Pricing Rules',
          component: mGaugePricingRules,
          meta: {roles: ['User', 'Admin'], subscription: ['mGauge']}
        },
        {
          path: 'mGauge/PricingRuleDetail/:policyId',
          name: 'mGauge Pricing Rule Detail',
          component: mGuagePricingRuleDetail,
          meta: {roles: ['User', 'Admin'], subscription: ['mGauge']}
        },
        {
          path: 'mScope/ReportHistory',
          name: 'mScope Report History',
          component: mScopeReportHistory,
          meta: { roles: ['Admin'], subscription: ['mScope'] }
        },
        {
          path: 'mScope/Settings',
          name: 'mScope Default Settings',
          component: mScopeSettings,
          meta: { roles: ['Admin'], subscription: ['mScope'] }
        },
        {
          path: 'mScope/RunReport',
          name: 'mScope Report Templates',
          component: mScopeRunReport,
          meta: { roles: ['Admin'], subscription: ['mScope'] }
        },
        {
          path: 'mScope/VehicleSets',
          name: 'mScope Vehicle Sets',
          component: mScopeVehicleSets,
          meta: { roles: ['Admin'], subscription: ['mScope'] }
        },
        {
          path: 'mScope/CompetitiveVehicleMapping',
          name: 'mScope Competitive Vehicle Mapping',
          component: mScopeCompetitiveVehicleMapping,
          meta: { roles: ['Admin'], subscription: ['mScope'] }
        },
        {
          path: 'mScope/VehicleSampling',
          name: 'mScope Vehicle Sampling',
          component: mScopeVehicleSampling,
          meta: { roles: ['Admin'], subscription: ['mScope'] }
        },
        {
          path: 'QuotePolicies',
          name: 'Inventory Quoting Rules',
          component: QuotePolicies,
          meta: {roles: ['Admin']}
        },
        {
          path: 'QuotePolicyDetail/:policyId',
          name: 'Inventory Quote Rule Details',
          component: QuotePolicyDetail,
          meta: {roles: ['Admin']}
        },
        {
          path: 'Inventory',
          name: 'Inventory',
          component: Inventory,
          meta: {roles: ['Admin']}
        },
        {
          path: 'EditInventory/:vehicleId',
          name: 'Edit Inventory',
          component: EditInventory,
          meta: {roles: ['Admin']}
        },
        {
          path: 'AddInventory',
          name: 'Add Inventory',
          component: AddInventory,
          meta: {roles: ['Admin']}
        },
        {
          path: 'Lenders',
          name: 'Lenders',
          component: Lenders,
          meta: {roles: ['Admin']}
        },
        {
          path: 'DealerDefinedFees',
          name: 'Dealer Defined Fees',
          component: DealerDefinedFees,
          meta: {roles: ['Admin']}
        },
        {
          path: 'RateMarkup',
          name: 'Rate Markup',
          component: RateMarkup,
          meta: {roles: ['Admin']}
        },
        {
          path: 'RateMarkupEx',
          name: 'Rate Markup Extended',
          component: RateMarkupEx,
          meta: { roles: ['Admin'] }
        },
        {
          path: 'BankFeeMarkup',
          name: 'Bank Fee Markup',
          component: BankFeeMarkup,
          meta: {roles: ['Admin']}
        },
        {
          path: 'CalculationSettings',
          name: 'Calculation Settings',
          component: CalculationSettings,
          meta: {roles: ['Admin']}
        },
        {
          path: 'MarketSpecificSettings',
          name: 'Market Specific Settings',
          component: MarketSpecificSettings,
          meta: {roles: ['Admin']}
        },
        {
          path: 'mDrive',
          name: 'mDrive',
          component: mDrive,
          meta: {roles: ['User', 'Admin'], subscription: ['mDrive']}
        },
        {
          path: 'DealerSettings',
          name: 'DealerSettings',
          component: DealerSettings,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'mProve',
          name: 'mProve',
          component: mProve,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'mProveSettings',
          name: 'mProveSettings',
          component: mProveSettings,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'mProveReport',
          name: 'mProveReport',
          component: mProveReport,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'mProveRawData',
          name: 'mProveRawData',
          component: mProveRawData,
          meta: {roles: ['Admin']}
        },
        {
          path: 'UserManagement',
          name: 'User Management',
          component: UserManagement,
          meta: {roles: ['Admin']}
        },
        {
          path: 'SettingsDifferences',
          name: 'Settings Differences',
          component: SettingsDifferences,
          meta: {roles: ['Admin']}
        },
        {
          path: 'UserManagementDetail/:userId',
          name: 'User Management Detail',
          component: UserManagementDetail,
          meta: {roles: ['Admin']}
        },
        {
          path: 'mProveSettingsAdd/:Subscriber_Id',
          name: 'mProveSettingsAdd',
          component: mProveSettingsAdd,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'MyProfile/:notification?',
          name: 'My Profile',
          component: MyProfile,
          meta: {roles: ['User', 'Admin']}
        },
        {
          path: 'VehicleEquipment',
          name: 'Vehicle Equipment',
          component: VehicleEquipment,
          meta: {roles: ['Admin']}
        },
        {
          path: 'RebateRegions',
          name: 'Rebate Regions',
          component: RebateRegions,
          meta: {roles: ['Admin']}
        },
        {
          path: '/mdesking',
          name: 'mDesking',
          meta: {roles: ['User', 'Admin'], subscription: ['mDesking'], url: 'https://www.mdesking.com'}
        },
        {
          path: '/academy',
          name: 'Academy',
          meta: {roles: ['User', 'Admin'], IsAcademy: true}
        },
        {
          path: 'PVI/Markets',
          name: 'PVI Markets',
          component: PVIMarkets,
          meta: { roles: ['Admin'], subscription: ['PVIREPORT'] }
        },
        {
          path: 'PVI/Settings',
          name: 'PVI Settings',
          component: PVISettings,
          meta: { roles: ['Admin'], subscription: ['PVIREPORT'] }
        },
        {
          path: 'PVI/ReportHistory',
          name: 'Reports',
          component: PVIReportHistory,
          meta: { roles: ['Admin'], subscription: ['PVIREPORT'] }
        },
        {
          path: 'PVI/EmailTemplate',
          name: 'PVI Email Template',
          component: PVIEmailTemplate,
          meta: { roles: ['Admin'], subscription: ['PVIREPORT'] }
        }
      ],
      meta: {roles: ['User', 'Admin']}
    },
    {
      path: '/ProgramInfo/:token',
      name: 'ProgramInfo',
      component: ProgramInfo,
      meta: {roles: ['Everyone']}
    },
    {
      path: '/mDriveWizard',
      name: 'mDrive Signup Wizard',
      component: mDriveWizard,
      meta: {roles: ['User', 'Admin']}
    },
    {
      path: '/DealerInformation',
      name: 'Dealer Information',
      component: DealerInformation,
      meta: {roles: ['Everyone']}
    },
    {
      path: '/mDriveSignup',
      name: 'mDriveSignup',
      component: mDriveSignup,
      meta: {roles: ['Everyone']}
    },
    {
      path: '/mDriveRegistration',
      name: 'mDriveRegistration',
      component: mDriveRegistration,
      meta: {roles: ['Everyone']}
    },
    {
      path: '/mDriveConfirmation',
      name: 'mDriveConfirmation',
      component: mDriveConfirmation,
      meta: {roles: ['Everyone']}
    },
    {
      path: '/mDriveEnrollment',
      name: 'mDriveEnrollment',
      component: mDriveEnrollment,
      meta: { roles: ['Everyone'] }
    },
    {
      path: '/EULA',
      name: 'EULA',
      component: eula,
      meta: {roles: ['Everyone']}
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js